module.exports = __webpack_public_path__ + "static/img/accommodation-view-tabs03.4c3df6d7.svg";